import { cn } from '@/utils/tailwind';

export const LayoutReviewContainer = ({
  children,
  className = '',
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        'flex-shrink-1 flex h-full w-full max-w-full flex-1 flex-col gap-[16px] overflow-x-hidden',
        className,
      )}
    >
      {children}
    </div>
  );
};

export const LayoutReviewControllerSection = ({
  children,
  className = '',
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return <div className={cn('grid gap-[16px]', className)}>{children}</div>;
};

export const LayoutReviewControllerContent = ({
  children,
  className = '',
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={cn('scrollbar flex  w-full justify-between gap-[20px] overflow-x-auto', className)}
    >
      {children}
    </div>
  );
};

export const LayoutReviewScrollArea = ({
  children,
  className = '',
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return <div className={cn('flex items-center gap-[20px]', className)}>{children}</div>;
};

export const LayoutReviewsBody = ({
  children,
  className = '',
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={cn('grid h-full min-h-0 w-full flex-1 overflow-x-hidden', className)}
      style={{ gridTemplateRows: '1fr auto' }} // 1fr: 남은 공간 모두 차지, auto: 콘텐츠 크기에 맞춤
    >
      <div className="flex min-h-0 flex-col overflow-auto">{children}</div>
    </div>
  );
};
